

export enum AppRoutes{
    Admin = "admin",
}